module.exports = __webpack_public_path__ + "img/turbo-vpn.93ab3ca.png";